// @flow
export const Units = {
  extraSmall: 4,
  small: 10,
  medium: 16,
  large: 25,
};

export const CameraSettingIdentifiers = {
  ShutterSpeed: 'ShutterSpeed',
  ISO: 'ISO',
  Exposure: 'Exposure',
  Focus: 'Focus',
  WhiteBalance: 'WhiteBalance',
};
